import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const DepartmentsReport = lazy(() => import('./DepartmentsReport'));

const DepartmentsReportConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.AttendanceReportAll,
  routes: [
    {
      path: 'apps/skud-departments-report',
      element: <DepartmentsReport />,
    },
  ],
};

export default DepartmentsReportConfig;
